const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '/',
    defaultPath: '/dashboard-merchandiser',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    listViewGridBaseProps: {
        pagination: true,
        paginationMode: 'server',
        rowsPerPageOptions: [5, 10, 20, 50, 100],
        filterMode: 'server',
        sortingMode: 'server',
        autoHeight: true,
        checkboxSelection: false,
        disableSelectionOnClick: true,
        disableColumnMenu: true
    },
    baseTextFieldProps: {
        fullWidth: true,
        variant: 'outlined',
        margin: 'dense',
        type: 'text'
    }
};

export default config;
